import React from 'react'
import BannersList from './BannersList'
import './Banners.sass'
import BannersManager from './BannersManager/BannersManager'

function Banners() {
  return (
    <div className="Banners">
      <BannersList onClickPath={'/settings/banners'} routerIdName="bannerId" />
      <BannersManager />
    </div>
  )
}

export default Banners
